import {writable} from "../web_modules/svelte/store.js";
export const page = writable("/");
export const busy = writable(false);
//# sourceMappingURL=app.js.map
